import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { AppSupportedLanguages } from 'src/app/core/languages-support/i18n-config.service';
import { I18nModule } from 'src/app/core/languages-support/i18n.module';
import { RadioButtonSelectionModule } from 'src/app/libs/ui/components/radio-button-selection/radio-button-selection.module';
import { SlidersModule } from 'src/app/libs/ui/components/sliders/sliders.module';
import { FlightsFiltersContainerComponent } from './flights-filters-container.component';

@NgModule({
  declarations: [
    FlightsFiltersContainerComponent,
  ],
  imports: [
    CommonModule,
    SlidersModule,
    I18nModule.forRoot(AppSupportedLanguages),
    MatExpansionModule,
    MatIconModule,
    RadioButtonSelectionModule,
  ],
  exports: [
    FlightsFiltersContainerComponent,
  ],
})
export class FlightsFiltersContainerModule { }
